/**
 * inventoryGroupApi.js
 * --------------------
 * API client for Inventory Group (MatGroup) Master using createMasterApiClient.
 * Connects directly to FastAPI backend /inventory-group/ endpoints.
 */
import { createMasterApiClient } from '../../common/masterApiFactory';

export const inventoryGroupClient = createMasterApiClient('inventory-group');

export const listInventoryGroups = (params) => inventoryGroupClient.list(params);
export const getInventoryGroupDetail = (id) => inventoryGroupClient.getById(id);
export const createInventoryGroup = (data) => inventoryGroupClient.create(data);
export const updateInventoryGroup = (id, data) => inventoryGroupClient.update(id, data);
export const archiveInventoryGroup = (id) => inventoryGroupClient.archive(id);
export const deleteInventoryGroup = (id) => inventoryGroupClient.remove(id);
export const getInventoryGroupOptions = () => inventoryGroupClient.getDropdownOptions();
